import {Component, EventEmitter, Input, Output} from '@angular/core';

import {numberD, numberToCurrency} from '../../../smoothr-web-app-core/utils/utils';
import {DisplayIdentifier} from '../../../smoothr-web-app-core/enums/DisplayIdentifier';

import {BehaviorSubject} from 'rxjs';
import {SubscriptionCategory} from 'src/smoothr-web-app-core/models/SubscriptionCategory';
import SubscriptionArticles from 'src/smoothr-web-app-core/models/Subscription';
import {TimeUnit} from 'src/smoothr-web-app-core/models/BillingPeriod';
import {SubscriptionTransaction} from 'src/smoothr-web-app-core/models/SubscriptionTransactions';
import moment from 'moment';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-subscription-item',
	templateUrl: './subscription.component.html',
	styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent {
	moment = moment;
	@Input() subscriptionCategory: SubscriptionCategory;
	@Input() userSubscriptionTransactionData: SubscriptionTransaction[] = [];
	@Output() selectedSubscription = new EventEmitter<{
		subscriptionCategoryId: string;
		subscription: SubscriptionArticles;
	}>();
	public isOpenSubscription$ = new BehaviorSubject<{isOpen: boolean; id: string}>({isOpen: false, id: ''});
	@Input() period: {
		factor: number;
		unit: TimeUnit;
	} = null;
	@Input() selectedInputSubscriptions: {subscriptionCategoryId: string; subscription: SubscriptionArticles}[];
	public no_subscription = 'no_subscriptions';
	// public selectedSubscriptions: {subscriptionCategoryId: string; subscription: SubscriptionArticles}[] = [];

	numberToCurrency = numberToCurrency;
	di = DisplayIdentifier;
	public isOpenArticle$ = new BehaviorSubject<{isOpen: boolean; id: string}>({isOpen: false, id: ''});

	constructor(public translate: TranslateService) {}
	selectedValue() {
		const subscSelected = this.selectedInputSubscriptions.find(
			v => v?.subscriptionCategoryId === this.subscriptionCategory?.id
		)?.subscription;

		return subscSelected ? subscSelected : this.no_subscription;
	}
	selectedOptionIndex() {
		const subscSelected = this.selectedInputSubscriptions.find(
			v => v?.subscriptionCategoryId === this.subscriptionCategory?.id
		)?.subscription;
		return this.subscriptionCategory.subscriptions.findIndex(subs => subs?._id === subscSelected?._id);
	}

	onSelectionChange(subscriptionCategoryId: string, subscription: SubscriptionArticles) {
		this.selectedSubscription.emit({subscriptionCategoryId, subscription});
	}

	changeOpening(id: string) {
		const isOpenValue = this.isOpenSubscription$.value;
		if (isOpenValue.id !== id) {
			this.isOpenSubscription$.next({isOpen: true, id});
		} else {
			this.isOpenSubscription$.next({isOpen: !this.isOpenSubscription$.value.isOpen, id});
		}
	}
	price(subscription: SubscriptionArticles, period: any) {
		if (subscription?.prices && subscription?.prices?.length > 0) {
			subscription.prices.find(it => {
				return it.period.unit === period.unit;
			});
			const price = subscription.prices.find(it => {
				return it.period.unit === period.unit;
			})?.price;
			if (price) {
				return numberD(price).toString();
			} else return 0;
		}
		return 0;
	}
	calculateEndSubscription(subscription: SubscriptionArticles) {
		const foundedTransation = (this.userSubscriptionTransactionData ?? []).find(
			it => it?.subscription?._id === subscription?._id
		);
		if (foundedTransation) {
			if (foundedTransation?.endsAt) {
				return this.translate.instant('subscription.ends_at') + moment(foundedTransation?.endsAt).format('DD.MM.YY');
			}
			return this.translate.instant('subscription.extended') + moment(foundedTransation.renewsAt).format('DD.MM.YY');
		}
		return null;
	}
	showIfUserHaveSubscriptionInList() {
		if (this.userSubscriptionTransactionData.length === 0) {
			return false;
		}
		const categoryMap = new Map(this.subscriptionCategory.subscriptions.map(it => [it._id, it]));
		const userHaveOneOfSubscriptionInList = this.userSubscriptionTransactionData.find(it =>
			categoryMap.has(it?.subscription?._id)
		);

		if (userHaveOneOfSubscriptionInList && userHaveOneOfSubscriptionInList?.cancelledAt) {
			return false;
		}
		if (userHaveOneOfSubscriptionInList && !userHaveOneOfSubscriptionInList?.cancelledAt) {
			return true;
		}
		return false;
	}
	duration(subscription: SubscriptionArticles) {
		if (subscription?.prices?.length > 0) {
			return (
				'(' +
				subscription.prices[0]?.period.factor +
				' ' +
				this.translate.instant('subscription.' + subscription.prices[0]?.period.unit) +
				')'
			);
		}
		return subscription.prices[0];
	}
}
